import { useEffect, useState } from "react";
import { GetAllInvoices, GetAllInvoicesCSV, Invoice, InvoicePerson, RefreshInvoiceData } from "../../services/purringService";
import { deleteCookie, getCookie } from "../../services/cookieService";
import styles from './purring.module.css';
import PurringLogin from "./purring";

function PurringAdministration() {
    const [people, setPeople] = useState<InvoicePerson[]>([]);
    const [authorized, setAuthorized] = useState(getCookie("invoiceToken") !== "");
    const [loading, setLoading] = useState(false);
    
    useEffect(() => {
       getInvoices();
    }, [authorized]);

    function getInvoices() {
        if(authorized) {
            setLoading(true);
            GetAllInvoices().then((x) => {
                setPeople(x.sort((a,b) => { 
                    if(a.name < b.name) {
                        return -1;
                    }
                    else if(a.name > b.name) {
                        return 1;
                    }
                    return 0;
                }));
                setLoading(false);
            })
            .catch((e) => {
                setAuthorized(false);
                deleteCookie("invoiceToken");
                setLoading(false);
            })
        }
    }

    function refreshDataInDb() {
        if(authorized) {
            setLoading(true);
            RefreshInvoiceData().then((x) => {
                setLoading(false);
            })
            .catch((e) => {
                setAuthorized(false);
                deleteCookie("invoiceToken");
                setLoading(false);
            })
        }
    }

    if(loading) {
        return (
            <div className={styles.purringAdminGrid}>
                <h2>Laster inn, vennligst vent...</h2>
            </div>
        )
    }
    
    if(authorized) {
        return (
            <div className={styles.purringAdminGrid}>
                <div className={`${styles.header}`}>
                    <h1>Purringer</h1>
                </div>
                <a href={"#"} onClick={GetAllInvoicesCSV} >Last ned Excel skjema av purringer med informasjon</a>
                <button onClick={refreshDataInDb}>Refresh data</button>
                <div className={styles.dataContainer}>
                    <div className={styles.peopleGrid}>
                        {
                            people?.map != null && people.map((x) => {
                                return (
                                    <PurringPersonBox data={x} refresh={() => getInvoices()} />
                                )
                            })
                        }
                    </div>
                </div>

            </div>
        );
    }

    return (
        <PurringLogin setAuthorized={setAuthorized}/>
    )
}

function getTotal(invoices: Invoice[]) {
    let total: number = 0;
    for (const invoice of invoices) {
        total += invoice.Amount;
    }
    return total;
}

function getEarliestInvoice(invoices: Invoice[]) {
    let earliestDate: Date = new Date();
    for (const invoice of invoices) {
        if(invoice.DueDate < earliestDate) {
            earliestDate = invoice.DueDate; 
        }
    }
    return earliestDate;
}

function PurringPersonBox(props: PurringPersonRowData) {

        return (
            <div className={styles.purringBox}>
                <h4>Navn:</h4>
                <h4>Antall purringer</h4>
                <span>{props.data.name}</span>
                <span>{props.data.invoices.length}</span>
                <h4>E-post:</h4>
                <h4>Total:</h4>
                <span>{props.data.email}</span>
                <span>{getTotal(props.data.invoices)}</span>
                <h4>Skulle vært betalt:</h4>
                <h4>Avtalegiro:</h4>
                <span>{getEarliestInvoice(props.data.invoices).toLocaleDateString("nb-NO")}</span>
                <span>{props.data.invoices.every(x => x.Avtalegiro) == true ? "Ja" : "Nei"}</span>
                <button onClick={() => window.location.href = `mailto:${props.data.email}`} className={styles.sendEmailButton}>Se purringer</button>
                <button onClick={() => window.location.href = `mailto:${props.data.email}`} className={styles.sendEmailButton}>Send e-post</button>
            </div>
        );
}

interface PurringPersonRowData {
    data: InvoicePerson;
    refresh: () => void;
}

export default PurringAdministration;